import { render, staticRenderFns } from "./ObjectTable.vue?vue&type=template&id=830eff98&scoped=true"
import script from "./ObjectTable.vue?vue&type=script&lang=js"
export * from "./ObjectTable.vue?vue&type=script&lang=js"
import style0 from "./ObjectTable.vue?vue&type=style&index=0&id=830eff98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830eff98",
  null
  
)

export default component.exports